import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { Version } from '../../_interfaces/version.interface';
import { QuestionGroup } from 'src/app/shared/interfaces/process-config.interface';
import { ProcessTypeEnum } from 'src/app/shared/interfaces/process.interface';
import { QuestionGroupAttributesComponent } from '../processes-questions-configuration/question-group/question-group-attributes/question-group-attributes.component';

@Component({
  selector: 'app-processes-configurations',
  templateUrl: './processes-configurations.component.html',
  styleUrls: ['./processes-configurations.component.scss'],
})
export class ProcessesConfigurationsComponent extends BaseClass implements OnInit {

  @Input() version: Version = null;
  @Input() selfEvaluationVersions: Version[] = [];
  @Input() userAttributesOnProcessAllowedFlag: boolean = false;
  @Output() initializeQuestionGroups: EventEmitter<void> = new EventEmitter<void>();
  @Output() buildGroupsSelectItems: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectManagerQuestionGroups: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectMainQuestionGroups: EventEmitter<void> = new EventEmitter<void>();

  public managerQuestionGroupsSelected = false;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _modalController: ModalController,
  ) {
    super(_toastController, _translationService);
  }

  ngOnInit() { }

  public managerQuestionGroupsAvailable(): boolean {
    return this.version && this.version.type === ProcessTypeEnum.ThreeSixtyEvaluation;
  }

  public selfEvaluationVersionChanged(value: number) {
    const self = this.selfEvaluationVersions.find((x) => x.id === value);
    this.version.questionGroups = self.questionGroups;
    this.initializeQuestionGroups.emit();
    this.buildGroupsSelectItems.emit();
  }

  public async manageProcessAttributes() {
    let emptyGroup: QuestionGroup;
    const modal = await this._modalController.create({
      component: QuestionGroupAttributesComponent,
      // cssClass: '',
      componentProps: {
        language: this.selectedLanguage,
        typeConfig: null,
        group: emptyGroup,
        version: this.version,
        consent: true,
        toProcess: true,
      },
    });

    return await modal.present();
  }
}
